import FinancialDepartment3 from "./Index";

const FinancialManagement = () => {
  return (
    <>
      <div className=" d-flex w-100">
        <div className="w-100">
          <FinancialDepartment3 />
        </div>
      </div>
    </>
  );
};

export default FinancialManagement;
